// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"db05f555","455":"a24da58e","488":"9c06c1cd"}[chunkId] + ".chunk.js";
};